import React, { useEffect } from 'react'
import { useDispatch, useSelector } from 'hooks/use-redux'
import { updateShortlist } from '@disco/state-management/actions/ShortlistActions'
import { SHOWCASES } from '@disco/constants/FeatureTypes'
import { useFeatureEnabled } from '@disco/state-management/selectors/business'
import { getShortlistById } from '@disco/state-management/selectors/shortlists'
import type { TabIdxType } from 'pages/explorer/shortlists/save/playlist-save-modal/constants'
import { PRESENTATION_TAB_IDX } from 'pages/explorer/shortlists/save/playlist-save-modal/constants'
import { Outlet, useLocation, useNavigate, useParams } from 'react-router-dom'
import PlaylistSaveModal from './PlaylistSaveModal'

const PlaylistSaveModalContainer = (props: {
  disabledSave?: boolean
  tabIndex: number
  children?: React.ReactNode
}): React.ReactNode => {
  const dispatch = useDispatch()
  const navigate = useNavigate()
  const location = useLocation()
  const params = useParams<{ shortlistId: string }>()
  const tabIndex = props.tabIndex
  const shortlist = useSelector(state =>
    getShortlistById(state, {
      id: params.shortlistId,
    }),
  )
  const shortlistsLoaded = useSelector(state => state.shortlists.loaded)
  const showcasesEnabled: boolean = useFeatureEnabled(SHOWCASES)
  useEffect(() => {
    if (
      tabIndex !== PRESENTATION_TAB_IDX &&
      shortlist?.showcase?.type &&
      !showcasesEnabled
    )
      dispatch(
        updateShortlist(shortlist?.id, {
          showcase: {
            type: null,
          },
          playlist_type: 'playlist',
        }),
      )
  }, [tabIndex])
  useEffect(() => {
    // DISCO-3223: shortlist is a client-only staging entity that only exists
    // in Redux once built up in-app, so a hard refresh on this route leaves
    // it null/undefined. Redirect instead of rendering the modal with it.
    if (shortlistsLoaded && !shortlist) {
      const returnPath = location.state?.returnPath || '/'
      navigate(returnPath)
    }
  }, [shortlist, shortlistsLoaded, location, navigate])
  if (!shortlist) return null
  return (
    <PlaylistSaveModal shortlist={shortlist} tabIndex={tabIndex}>
      {props.children}
      <Outlet />
    </PlaylistSaveModal>
  )
}

export default PlaylistSaveModalContainer
